import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';
import { LsHelperService } from './ls-helper.service';
import { UtilsService } from './utils.service';

import { TransactionRequirementService } from 'src/app/pages/transaction/services/transaction-requirement.service';
import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';

@Injectable({
	providedIn: 'root'
})
export class DynamicFormService extends BaseProvider {
	isLinear = false;
	isReadOnly = false;
	isInRevisionMode = false;
	isComplete = false;
	isLoadingForm = false;
	costTypeId: any;

	formLoaderIsVisible = false;
	formName: any;

	requirement: any;

	formCommunicator = new Subject();

	revisionMode = false;

	constructor(
		public globals: GlobalsService,
		public http: HttpClient,
		public ls: LsHelperService,
		public transactionRequirementService: TransactionRequirementService,
		public utilsService: UtilsService,
		public transactionService: TransactionService,
	) {
		super();
		this.baseUrl = 'userProcessRequirement';
	}

	save(data) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
				'/process/' + this.requirement.ProcessId +
				'/complete/' + this.isComplete;

			this.http
				.post(
					this.url,
					data
				)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						this.transactionRequirementService.updateItemByField(
							item.UserProcessRequirementId,
							'UserProcessRequirementId',
							item
						);

						this.transactionService.getById(this.transactionService.itemToEdit.Id);
						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	saveImage(data, extensionIMG) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
				'/photo';
			data.extensionIMG = extensionIMG;
			this.http
				.post(
					this.url,
					data
				)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						this.transactionRequirementService.updateItemByField(
							item.UserProcessRequirementId,
							'UserProcessRequirementId',
							item
						);
						this.transactionService.transactionRefresher.next();
						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	saveDataForm(data, extensionIMG) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + 'companion' +
				'/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
				'/photo';
			data.extensionIMG = extensionIMG;
			this.http
				.post(
					this.url,
					data
				)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						this.transactionRequirementService.updateItemByField(
							item.UserProcessRequirementId,
							'UserProcessRequirementId',
							item
						);
						this.transactionService.transactionRefresher.next();
						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	saveExcel(data) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
				'/excel';
			this.http
				.post(
					this.url,
					data
				)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						this.transactionRequirementService.updateItemByField(
							item.UserProcessRequirementId,
							'UserProcessRequirementId',
							item
						);
						this.transactionService.transactionRefresher.next();
						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	readExcel(file) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/readExcel/';

			const formData = new FormData();
			formData.append('file', file, file.name);
			formData.append('processId', this.requirement.ProcessId);
			this.http
				.post(
					this.url,
					formData
				)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}

	saveCosts(costs) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/process/' + this.requirement.ProcessId +
				'/costs';

			const costsStr = JSON.stringify(costs);

			this.http
				.post(
					this.url,
					{ costs: costsStr }
				)
				.subscribe(
					(data: any) => {
						resolve(null);
					},
					err => { reject(err); }
				);
		});
	}

	saveIndex(index) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/requirement/' + this.requirement.UserProcessRequirementId +
				'/index';


			this.http
				.post(
					this.url,
					{ index }
				)
				.subscribe(
					(data: any) => {
						resolve(null);
					},
					err => { reject(err); }
				);
		});
	}

	getByModuleName(moduleName) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/module/' + moduleName;

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	getCadastreNumber() {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl +
				'/dynamicForm/cadastreNumber/' + this.transactionService.itemToEdit.Id;

			this.http.get(
				this.url
			)
				.subscribe(
					(data: any) => {
						const item = data.Data;

						resolve(item);
					},
					err => { reject(err); }
				);
		});
	}

	uploadFileQuerellaForm(params) {
		return new Promise((resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/uploadFile';

			this.http
				.post(
					this.url,
					params
				)
				.subscribe(
					(data: any) => {
						resolve(data.Data);
					},
					err => { reject(err) }
				);
		});
	}

	async getFileQuerellaForm(fileName: string) {
		const queryParams = new HttpParams().set('fileName', fileName.toString());
		return await new Promise((resolve, reject) => {
			this.url = `${this.globals.dataUrl}${this.baseUrl}/getFileQuerellaForm`;

			this.http
				.get(this.url, { responseType: 'arraybuffer', params: queryParams })
				.subscribe(
					(data) => {
						const blob = new Blob([data], { type: this.getMimeType(fileName) });
						const url = window.URL.createObjectURL(blob);
						resolve(url);
					},
					err => { reject(err); }
				);
		});
	}

	/**
	 * Limpia todos los datos relacionados con los formularios dinámicos
	 * Se llama cuando se abandona el componente transaction-management
	 */
	clearDynamicFormData() {
		this.isLinear = false;
		this.isReadOnly = false;
		this.isInRevisionMode = false;
		this.isComplete = false;
		this.isLoadingForm = false;
		this.costTypeId = null;
		this.formLoaderIsVisible = false;
		this.formName = null;
		this.requirement = null;
		this.revisionMode = false;
		
		// Limpiar formCommunicator
		this.formCommunicator = new Subject();
		
		console.log('DynamicFormService: datos limpiados');
	}

	private getMimeType(fileName: string) {
		// Determinar el tipo MIME basado en la extensión del archivo
		const fileExtension = fileName.split('.').pop().toLowerCase();
		let mimeType = 'application/octet-stream'; // tipo por defecto

		switch (fileExtension) {
			case 'pdf':
				mimeType = 'application/pdf';
				break;
			case 'jpg':
			case 'jpeg':
				mimeType = 'image/jpeg';
				break;
			case 'png':
				mimeType = 'image/png';
				break;
			case 'gif':
				mimeType = 'image/gif';
				break;
			case 'doc':
				mimeType = 'application/msword';
				break;
			case 'docx':
				mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				break;
			case 'xls':
				mimeType = 'application/vnd.ms-excel';
				break;
			case 'xlsx':
				mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				break;
			case 'txt':
				mimeType = 'text/plain';
				break;
		}
		return mimeType;
	}

	getCompanionByUserProcessId(userProcessId) {
		return new Promise((resolve, reject) => {
			this.url = `${this.globals.dataUrl}companion/getByUserProcessId/${userProcessId}`;
			this.http
				.get(this.url)
				.subscribe(
					(data: any) => {
						resolve(data);
					},
					err => { reject(err); }
				);
		});
	}
}
